<template>
  <div class="team container">
    <div class="header-text">
      <div class="pre-header"></div>
      <h1>{{ $t('views.team.aboutUs') }}</h1>
      <h3>{{ $t('views.team.theIncomeMarketplace') }}</h3>
      <h3>{{ $t('views.team.theIncomeTeam') }}</h3>
    </div>
    <team-member v-for="(member, index) in members.chiefs"
                 v-bind:float="index%2===0?'right':'left'"
                 v-bind:key="member.name"
                 v-bind:member="member"></team-member>
    <div class="board">
      <div class="title">{{ $t('views.team.supervisoryBoard') }}</div>
      <div class="description">{{ $t('views.team.theSupervisoryBoard') }}</div>
    </div>
    <team-member v-for="(member, index) in members.supervisors"
                 v-bind:float="index%2===0?'right':'left'"
                 v-bind:key="member.name"
                 v-bind:member="member"></team-member>
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="home-start-investing">
            <h2>{{ $t('views.team.startInvestingToday') }}</h2>
            <div class="detail-info">{{ $t('views.team.earnUpTo') }}</div>
            <get-started/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GetStarted from '../components/GetStarted'
import TeamMember from '@/components/TeamMember'

export default {
  name: 'Team',
  components: {
    TeamMember,
    GetStarted
  },
  data()
  {
    return {
      members: {
        chiefs: [
          {
            name: 'views.team.members.kimmo.name',
            position: 'views.team.members.kimmo.position',
            description: 'views.team.members.kimmo.description',
            link: {
              url: 'https://www.linkedin.com/in/kimmo-rytkonen/',
              title: 'views.team.members.kimmo.linkTitle'
            },
            image: 'kimmo.jpeg'
          },
          {
            name: 'views.team.members.juri.name',
            position: 'views.team.members.juri.position',
            description: 'views.team.members.juri.description',
            link: {
              url: 'https://www.linkedin.com/in/j%C3%BCri/'
            },
            image: 'juri.jpeg'
          },
          {
            name: 'views.team.members.maciej.name',
            position: 'views.team.members.maciej.position',
            description: 'views.team.members.maciej.description',
            link: {
              url: 'https://www.linkedin.com/in/maciej-wenerski-54295171/'
            },
            image: 'maciej_wenerski.jpeg'
          }
        ],
        supervisors: [
          {
            name: 'views.team.supervisors.pedro.name',
            position: '',
            description: 'views.team.supervisors.pedro.description',
            link: {url: 'https://www.linkedin.com/in/pedrotavares-altimapa/'},
            image: 'pedro_tavares.png'
          },
          {
            name: 'views.team.supervisors.karl.name',
            position: '',
            description: 'views.team.supervisors.karl.description',
            link: {
              url: 'https://www.linkedin.com/in/karl-hauptmann-00565326/'
            },
            image: 'karl_hauptmann.jpeg'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
.team .row {
  text-align: center;
  width: 100%;
  display: inline-block;
}

.header-text {
  text-align: center;
  margin-top: 62px;
  margin-bottom: 75px;

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 60px;
    line-height: 64px;
    text-align: center;
    color: #000000;
    flex: none;
    max-width: 725px;
    margin: auto auto 15px;

    .blue {
      color: #30A7FE;
    }
  }

  h3 {
    font-style: normal;
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    color: #6E777A !important;
    flex: none;
    order: 2;
    align-self: center;
    margin: auto auto 16px;
    text-align: justify;
    flex: none;
    max-width: 1060px;
  }

  .pre-header {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #9DA0A6;
    flex: none;
    order: 0;
    align-self: center;
    margin: 0 16px 15px;
  }
}

.simple-it-gets {
  background-color: #000000;
  color: #FFFFFF;
  text-align: center;

  h2 {
    margin-top: 50px;
    margin-bottom: 16px;
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 40px;
    text-align: center;
    color: #FFFFFF;
  }

  img {
    max-width: 642px;
    width: 100%;
    margin-bottom: 35px;
  }
}

.home-start-investing {
  text-align: center;
  margin-top: 80px;
  margin-bottom: 100px;
  font-style: normal;

  h2 {
    font-size: 36px;
    line-height: 40px;
    font-weight: bold;
    color: #000000;
  }

  .detail-info {
    font-weight: normal;
    font-size: 21px;
    line-height: 28px;
    color: #9DA0A6;
  }
}

.ensuring-description {
  font-size: 21px;
  line-height: 28px;
  text-align: center;
  color: #9DA0A6;
  max-width: 800px;
  margin: auto auto 20px;
}

.equal-opportunity {
  border: 1px solid #D6D6D6;
  box-sizing: border-box;
  border-radius: 10px;
  background-image: url("../assets/team/team-member.svg");
  background-position: left 0;
  background-repeat: no-repeat;
  height: auto;
  margin-bottom: 40px;
  margin-top: 40px;

  .circle {
    background: #30A7FE;
    border-radius: 108px;
    border: 10px solid #30A7FE;
    font-weight: bold;
    font-size: 18px;
    line-height: 30px;
    text-align: center;
    color: #FFFFFF;
    max-width: 270px;
    font-style: normal;
    padding: 38px;
    margin: 120px auto auto 56%;
  }

  .text {
    margin-top: 100px;
    margin-bottom: 100px;
    margin-left: 50px;

    .head {
      font-style: normal;
      font-weight: bold;
      font-size: 36px;
      line-height: 40px;
      color: #000000;
      flex: none;
      order: 0;
      align-self: flex-start;
      margin: 0 16px;
    }

    .info {
      font-style: normal;
      font-weight: normal;
      font-size: 21px;
      line-height: 28px;
      color: #6E777A;
      flex: none;
      order: 1;
      align-self: flex-start;
      margin: 0 16px;
    }
  }
}

.info-img {
  text-align: center;
  width: 100%;

  img {
    max-width: 80px;
  }
}

.compare-ways {
  text-align: center;
  margin-top: 25px;

  h2 {
    font-style: normal;
    font-weight: bold;
    font-size: 36px;
    line-height: 40px;
    text-align: center;
    color: #000000;
    margin-bottom: 10px;
  }

  table {
    margin-top: 15px;
  }
}

.board {
  margin-top: 80px;
  margin-bottom: 60px;
  text-align: center;

  .title {
    font-style: normal;
    font-weight: bold;
    font-size: 48px;
    line-height: 50px;
  }

  .description {
    font-style: normal;
    font-weight: bold;
    font-size: 21px;
    line-height: 22px;
  }
}

@media (max-width: 700px) {
  .team {
    .col-lg-12 {
      padding-left: 0;
      padding-right: 0;
    }
  }
}
</style>
